#import "../fragments/context-document-fragment.graphql"

query GetContextDocuments($includeExcluded: Boolean!, $sourceType: DocumentSourceTypeEnum) {
    contextDocuments(includeExcluded: $includeExcluded, sourceType: $sourceType) {
        ...ContextDocumentFragment
    }
    primaryContextDocument {
        ...ContextDocumentFragment
        previewUrl
        shareablePreviewUrl
        canEmbedIframe
    }
}
